import {
    Button,
    Divider,
    Grid,
    Group,
    Select,
    Stack,
    Textarea,
    Title,
} from "@mantine/core";
import ShipmentTrackingTypeSelect from "../Shipment.trackingType.select/Shipment.trackingType.select";
import {useForm} from "@mantine/form";
import {ArrowRight} from "tabler-icons-react";

interface Props {
    onSubmitQuery?: (query: any) => void,
}

function ShipmentQuickTrack(props: Props) {
    const {onSubmitQuery} = props;
    const form = useForm({
        initialValues: {
            trackingType: "ContainerNumber",
            searchType: "Partial",
            query: ""
        }
    })

    function onSubmit(values: typeof form.values) {
        if (onSubmitQuery) {
            onSubmitQuery(values)
        }
    }

    return (
        <Stack>
            <Title order={3}>
                Quick Track
            </Title>
            <Divider/>
            <form onSubmit={form.onSubmit(onSubmit)}>
                <Grid>
                    <Grid.Col span={8}>
                        <ShipmentTrackingTypeSelect label="Tracking Type" {...form.getInputProps("trackingType")}/>
                    </Grid.Col>
                    <Grid.Col span={4}>
                        <Select label="Search Type" data={[{value: "Partial", label: "Partial"}, {
                            value: "Exact",
                            label: "Exact"
                        }]} {...form.getInputProps("searchType")}/>
                    </Grid.Col>
                    <Grid.Col span={12}>
                        <Textarea label="Query"
                                  description="Paste up to 50 search values. Values should be comma separated."
                                  minRows={3} {...form.getInputProps("query")}/>
                    </Grid.Col>
                </Grid>
                <Group mt={24} position="right">
                    <Button type="submit" rightIcon={<ArrowRight/>}>
                        Submit
                    </Button>
                </Group>
            </form>
        </Stack>
    )
}

export default ShipmentQuickTrack;